import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = ({ allowedRoles }) => {
  const tokenString = localStorage.getItem("token");
  const token = tokenString ? JSON.parse(tokenString) : null;

  const userRoleId = token?.role?.id;

  if (!token || !userRoleId) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(userRoleId)) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
